import { useSelector } from "react-redux"
import LoginPage from "../scenes/LoginPage.scenes";
import { useLocation } from "react-router-dom";
import { selectIsAuthenticated } from "../store/sessionSelectors";

interface AuthGuardProps extends React.HTMLAttributes<HTMLElement> {

}

export const AuthGuard = ({children}: AuthGuardProps) => {
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const path = useLocation().pathname
    return isAuthenticated
        ?   <>{children}</>
        :   <LoginPage routeBackTo={path} shouldLogout={false}></LoginPage>
}